<template>
  <v-menu
    ref="menu"
    v-model="menu"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    max-width="350px"
  >
    <template v-slot:activator="{ on }">
      <v-text-field
        v-model="value"
        :label="label"
        :error-messages="errorMessages"
        prepend-icon="event"
        readonly
        v-on="on"
      >
      <template v-slot:append>
        <v-btn @click="$parent.changedate" small tile text color="primary">{{$store.getters.settings.datetype}}</v-btn>
      </template>
      </v-text-field>
    </template>
    <v-card>
      <v-card-text class="pad0">
        <v-container grid-list-md>
          <v-layout wrap>
            <v-flex xs12 sm4 md4>
              <v-autocomplete autocomplete="off" dense v-model="year" :items="yearList" :label="$t('language.year')"></v-autocomplete>
            </v-flex>
            <v-flex xs12 sm4 md4>
              <v-autocomplete
                autocomplete="off"
                dense
                v-model="month"
                :items="monthList"
                item-text="text"
                item-value="id"
                :label="$t('language.month')"
              ></v-autocomplete>
            </v-flex>
            <v-flex xs12 sm4 md4>
              <v-autocomplete autocomplete="off" dense v-model="day" :items="dayList" :label="$t('language.day')"></v-autocomplete>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-card-actions class="pad0">
        <v-spacer />
        <v-btn text color="primary" @click="menu = false">Cancel</v-btn>
        <v-btn text color="primary" @click="updateDate">OK</v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
import nepaliDate from "../../shared/nepalidate";
export default {
  props: ["value", "label", "errorMessages"],
  data() {
    return {
      menu: false,
      year: null,
      month: null,
      day: null,
      yearList: nepaliDate.getYears(),
      monthList: [
        { id: "01", text: "Baisakh" },
        { id: "02", text: "Jestha" },
        { id: "03", text: "Asadh" },
        { id: "04", text: "Shrawan" },
        { id: "05", text: "Bhadra" },
        { id: "06", text: "Ashoj" },
        { id: "07", text: "Kartik" },
        { id: "08", text: "Mangsir" },
        { id: "09", text: "Poush" },
        { id: "10", text: "Magh" },
        { id: "11", text: "Falgun" },
        { id: "12", text: "Chaitra" }
      ]
    };
  },
  computed: {
    dayList() {
      let maxday = 30;
      if (this.year != null && this.month != null) {
        maxday = nepaliDate.getDaysInMonth(this.year, parseInt(this.month));
      }
      if (this.day > maxday) this.day = null;
      var list = [];
      for (var i = 1; i <= maxday; i++) {
        list.push(nepaliDate.pad(i));
      }
      return list;
    }
  },
  watch: {
    menu: function(newval, oldval) {
      if (newval) {        
          let date = nepaliDate.parseNepaliDate(this.value);
          if(date.year == null){
            let today = nepaliDate.parseNepaliDate(nepaliDate.getTodayNepaliDate());
            this.year = today.year;
          }
          else
          this.year = date.year;
          this.month = date.month;
          this.day = date.day;
      }
    }
  },
  methods: {
    updateDate() {
      this.$emit("input", nepaliDate.stringifyNepaliDate(this.year,parseInt(this.month),parseInt(this.day)));
      this.menu = false;
    }    
  }
};
</script>
